var _defs, _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogocomunidad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1080 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .st0 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .st1 {\r\n        fill: none;\r\n      }\r\n\r\n      .st2 {\r\n        clip-path: url(#clippath);\r\n      }\r\n\r\n      .st3 {\r\n        opacity: .5;\r\n      }\r\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    x: 147.94,
    y: 88.43,
    width: 756.99,
    height: 864.04
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M490.89,527.45l241.7-4.09c0-46.47.67-88.85-15.25-133.51-12.04-33.8-37.71-76.58-72.35-91.37-.4-.17-23.24,44.44-24.87,47.51-1.33,2.51-2.68,5.11-2.94,7.93-.32,3.41.98,6.74,2.26,9.91,6.69,16.62,15.08,33.36,20.32,50.48,4.62,15.08,3.33,28.53,6.12,44.06l-93.03-.05h-116.68s-18.72,48.97,54.72,69.13"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M557.87,328.72c.09-.34-40.55-.33-43.01-.12-31.6,2.75-63.44,11.37-90.07,29.06-118.25,78.55-63.2,301.07,82.68,303.72.02,0,79.21,1.44,138.25-46.08,0,0,56.11,61.87,56.16,61.93.7.77-38.89,27.06-41.21,28.42-32.62,19.13-68.5,33.64-105.94,39.73-83.46,13.58-168.82-26.61-219.36-92.81-54.73-71.67-62-168.01-33.83-251.84,0,0,60.49-178.57,272.18-132.49,0,0-15.82,60.39-15.84,60.49"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M519.69,952.48h-.45l-1.41-.02-1.31-.51c-46.5-17.96-105.73-44.27-168.45-72.12-69.93-31.06-142.24-63.17-194.35-82.22l-5.16-1.88v-403.04c0-11.18-.17-21.48-.34-31.44-1.03-60.75-1.71-100.88,46.95-132.75l.54-.36.59-.26,275.82-121.59c2.96-1.32,5.94-2.73,8.92-4.13,20.8-9.79,44.37-20.88,73.47-7.63,31.04,12.89,75.6,32.67,122.79,53.61,80.48,35.72,171.7,76.2,222.44,94.34l5.21,1.86v51.79h-15.72v-40.75c-52.1-19.12-140.24-58.24-218.31-92.89-47.16-20.93-91.7-40.69-122.57-53.51l-.26-.12c-22.53-10.31-40.06-2.06-60.36,7.5-3.08,1.45-6.16,2.9-9.25,4.28l-275.24,121.33c-40.86,27.05-40.35,57.86-39.31,118.99.17,10.03.35,20.4.35,31.71v392.07c52.12,19.41,122.27,50.56,190.17,80.72,61.9,27.48,120.41,53.47,166.33,71.28,49.49-1.56,295.74-119.49,329.71-139.17l7.88,13.6c-28.47,16.49-284.79,141.3-338.68,141.3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogocomunidad);
export default __webpack_public_path__ + "static/media/Logo comunidad.8800891c7b1fc868cca6bc8b87454d0f.svg";
export { ForwardRef as ReactComponent };